export const workflowListMessages = {
  listView: 'List',
  graphView: 'Graph',
  viewSwitcherLabel: 'Workflow view',
  graphRegionLabel: 'Workflow dependency graph',
  graphCanvasLabel: 'Workflow dependency graph canvas',
  graphControlsLabel: 'Workflow dependency graph controls',
  graphZoomIn: 'Zoom in',
  graphZoomOut: 'Zoom out',
  graphFit: 'Fit',
  graphLoading: 'Loading workflow dependency graph',
  graphDefinitionWarning:
    'Some workflow definitions could not be loaded. Their workflows are still shown, but some dependencies may be missing.',
  graphNodesLabel: 'Workflows in this graph',
  graphEdgesLabel: 'Workflow dependencies',
  invokes: (source: string, target: string) => `${source} invokes ${target}`,
  openWorkflow: (name: string) => `Open workflow ${name}`,
  workflowDescription: (name: string, metadata: readonly string[]) =>
    metadata.length > 0 ? `${name}: ${metadata.join(', ')}` : name,
  unpublishedChanges: 'Unpublished changes',
} as const;
